import { useEffect, useState } from "react";
import axios from "axios";
import { MessageCircle } from "lucide-react";
import { T } from "@/locales/tr";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const DEFAULT_MSG = "Saalam Papicoo, je viens du site papicoo.com — j'aimerais échanger avec toi.";

/**
 * Bouton flottant WhatsApp avec tracking.
 * Au clic : POST /api/whatsapp/click puis ouverture de wa.me/<number>?text=...
 * Se cache automatiquement si PAPICOO_WHATSAPP n'est pas configuré côté serveur.
 */
export default function FloatingWhatsApp({ source = "floating", message = DEFAULT_MSG }) {
  const [number, setNumber] = useState(null);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    axios.get(`${API}/whatsapp/config`).then((r) => {
      setEnabled(!!r.data?.enabled);
      setNumber(r.data?.number || null);
    }).catch(() => {});
  }, []);

  const handleClick = (e) => {
    e.preventDefault();
    // Tracking non-bloquant
    axios.post(`${API}/whatsapp/click`, { source }).catch(() => {});
    const url = `https://wa.me/${number}?text=${encodeURIComponent(T(message))}`;
    window.open(url, "_blank", "noopener,noreferrer");
  };

  if (!enabled || !number) return null;

  return (
    <a
      href={`https://wa.me/${number}?text=${encodeURIComponent(T(message))}`}
      data-testid="floating-whatsapp-btn"
      onClick={handleClick}
      aria-label={T("Contacter Papicoo sur WhatsApp")}
      className="fixed bottom-5 right-[140px] sm:right-[170px] z-50 inline-flex items-center gap-2 pl-2.5 pr-4 py-2 rounded-full bg-[#25D366] text-white shadow-xl hover:shadow-2xl transition-all hover:-translate-y-0.5"
    >
      <span className="relative inline-flex">
        <MessageCircle size={20} className="text-white" />
        <span className="absolute -bottom-1 -right-1 w-2.5 h-2.5 rounded-full bg-white border border-[#25D366]" />
      </span>
      <span className="text-sm font-medium hidden sm:inline">{T("WhatsApp")}</span>
    </a>
  );
}
